<ng-template>
   <div lcsSingleSelectPanel [visible]="isPanelVisible">
      @if (isIncludeEmptyOption) {
      <lcs-option></lcs-option>
      } @for (account of accounts | async; track trackBy(account)) {
      <lcs-option [value]="account" id="lcs-option-id-{{ account.accountId }}">
         {{ account.name }}
      </lcs-option>
      }
   </div>
</ng-template>
